import { Injectable, inject } from '@angular/core';

import { Types } from '../../types.domain';

import { GetPublicCityListServiceInterface } from '../interfaces/services/get-public-city-list.service.interface';
import { GetPublicCityListInput } from '../dtos/get-public-city-list.input';
import { PublicCityListItem } from '../dtos/get-public-city-list.output';

@Injectable()
export class GetPublicCityListService implements GetPublicCityListServiceInterface {
  private readonly _cityRepository = inject(Types.CityRepository);

  async handle(input: GetPublicCityListInput = {}): Promise<PublicCityListItem[]> {
    return await this._cityRepository.getPublicList(input);
  }
}
